<template>
  <div>
    余额明细
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>